var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1460,
    height: 1460,
    viewBox: "0 0 1460 1460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1243.96 1243.83H1027.66V905.107C1027.66 824.334 1026.22 720.356 915.172 720.356C802.517 720.356 785.279 808.357 785.279 899.224V1243.8H568.993V547.254H776.628V642.443H779.541C821.817 570.158 900.716 526.824 984.408 529.931C1203.63 529.931 1244.05 674.123 1244.05 861.714L1243.96 1243.83ZM324.944 452.038C324.931 452.038 324.924 452.038 324.917 452.038C256.06 452.038 199.399 395.384 199.399 326.527C199.399 257.67 256.06 201.009 324.917 201.009C393.768 201.009 450.422 257.656 450.435 326.501C450.435 326.507 450.435 326.514 450.435 326.527C450.435 395.371 393.788 452.031 324.944 452.038ZM433.087 1243.83H216.571V547.254H433.087V1243.83ZM1351.78 0.15051H107.879C49.4886 -0.508941 0.878555 46.9715 0.16687 105.362V1354.43C0.852438 1412.85 49.456 1460.38 107.879 1459.76H1351.78C1410.35 1460.5 1459.12 1412.97 1459.9 1354.43V105.277C1459.12 46.7625 1410.28 -0.711397 1351.78 0.0590516V0.15051Z",
    fill: "#0A66C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.0b39adb2.svg";
export { ForwardRef as ReactComponent };